module.exports = __webpack_public_path__ + "img/H-63-ER-450-BE.2857507e.png";